// From: https://github.com/pixijs/pixi-filters/tree/master/filters/outline
// NOTE: Was having difficulties including this package through npm, so included it directly in the project
export class OutlineFilter extends PIXI.Filter<any> {
    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;

        uniform vec2 thickness;
        uniform vec4 outlineColor;
        uniform vec4 filterClamp;

        const float DOUBLE_PI = 3.14159265358979323846264 * 2.;

        void main(void) {
            vec4 ownColor = texture2D(uSampler, vTextureCoord);
            vec4 curColor;
            float maxAlpha = 0.;
            vec2 displaced;
            for (float angle = 0.; angle <= DOUBLE_PI; angle += 0.5) {
                displaced.x = vTextureCoord.x + thickness.x * cos(angle);
                displaced.y = vTextureCoord.y + thickness.y * sin(angle);
                curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));
                maxAlpha = max(maxAlpha, curColor.a);
            }
            float resultAlpha = max(maxAlpha, ownColor.a);
            resultAlpha = resultAlpha * ceil(vTextureCoord.x) * (1. - floor(vTextureCoord.x));
            resultAlpha = resultAlpha * ceil(vTextureCoord.y) * (1. - floor(vTextureCoord.y));
            gl_FragColor = vec4((ownColor.rgb + outlineColor.rgb * (1. - ownColor.a)) * resultAlpha, resultAlpha);
        }
    `;

    constructor() {
        super(undefined, OutlineFilter.FRAG);
    }
}
